// SPDX-License-Identifier: Apache-2.0

import { jsonMember, jsonObject } from "typedjson";
import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";

@jsonObject
export default class Dispose extends PerunMessage {
  @jsonMember(String) clientAddress: string;

  constructor(clientAddress: string) {
    super();
    this.clientAddress = clientAddress;
  }

  messageType(): MessageType {
    return Dispose;
  }

  messageTypeName(): MessageTypeName {
    return "Dispose";
  }
}
